import React from "react";
import { TIPTAP_HTML_TYPE } from "./../ricos-content/index.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import {
  HeightIcon,
  selectedNodeResolver,
  WidthIcon
} from "./../plugin-commons/index.js";
import {
  FLOATING_PLUGIN_TOOLBAR,
  NodeAlignmentButton
} from "./../toolbars-v3/index.js";
import { HTML_BUTTONS, HTML_EDIT_MODAL_ID } from "./consts.js";
import {
  PLUGIN_TOOLBAR_CONTAINER_HEIGHT_BUTTON,
  PLUGIN_TOOLBAR_CONTAINER_WIDTH_BUTTON,
  PLUGIN_TOOLBAR_EDIT_HTML_BUTTON
} from "./data-hooks.js";
import { MAX_HEIGHT, MAX_WIDTH, MIN_HEIGHT, MIN_WIDTH } from "./defaults.js";
import { DimensionSliderButton } from "./toolbar/DimensionSliderButton.js";
import { EditHtmlButton } from "./toolbar/EditHtmlButton.js";
import { SliderModal } from "./toolbar/SliderModal.js";
const getToolbarButtons = (config, services) => {
  const {
    minHeight = MIN_HEIGHT,
    maxHeight = MAX_HEIGHT,
    maxWidth = MAX_WIDTH,
    minWidth = MIN_WIDTH
  } = config || {};
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: HTML_BUTTONS.edit,
      dataHook: PLUGIN_TOOLBAR_EDIT_HTML_BUTTON,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(EditHtmlButton, { id: HTML_EDIT_MODAL_ID, toolbarItem }),
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: HTML_BUTTONS.width,
      command: ({ tiptapEditor, referenceElement, attributes: { selectedNode } }) => {
        const { attrs } = selectedNode;
        const onChange = ({ value }) => {
          const changedData = {
            ...attrs,
            containerData: {
              ...attrs.containerData,
              width: {
                custom: value
              }
            }
          };
          setTimeout(() => {
            tiptapEditor.chain().updateAttributes(TIPTAP_HTML_TYPE, changedData).run();
          }, 0);
        };
        const componentProps = {
          onChange,
          closeModal: () => modals.closeModal(HTML_BUTTONS.width),
          min: minWidth,
          max: maxWidth,
          dimension: "width",
          nodeId: selectedNode.attrs.id
        };
        modals.togglePluginPanel({
          isMobile,
          id: HTML_BUTTONS.width,
          Component: SliderModal,
          componentProps,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: isMobile ? "bottom" : "right-start"
          },
          focusReturnElement: referenceElement,
          mobileLayout: "drawer"
        });
      },
      icon: WidthIcon,
      tooltip: "ChangeDimensions_Width_Tooltip",
      dataHook: PLUGIN_TOOLBAR_CONTAINER_WIDTH_BUTTON,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DimensionSliderButton, { toolbarItem, dimension: "width" }),
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: HTML_BUTTONS.height,
      command: ({ tiptapEditor, referenceElement, attributes: { selectedNode } }) => {
        const { attrs } = selectedNode;
        const onChange = ({ value, autoHeight }) => {
          const changedData = {
            ...attrs,
            containerData: {
              ...attrs.containerData,
              height: {
                custom: value
              }
            },
            autoHeight
          };
          setTimeout(() => {
            tiptapEditor.chain().updateAttributes(TIPTAP_HTML_TYPE, changedData).run();
          }, 0);
        };
        const componentProps = {
          onChange,
          closeModal: () => modals.closeModal(HTML_BUTTONS.height),
          min: minHeight,
          max: maxHeight,
          dimension: "height",
          nodeId: selectedNode.attrs.id
        };
        modals.togglePluginPanel({
          isMobile,
          id: HTML_BUTTONS.height,
          Component: SliderModal,
          componentProps,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: isMobile ? "bottom" : "right-start"
          },
          focusReturnElement: referenceElement,
          mobileLayout: "drawer"
        });
      },
      icon: HeightIcon,
      tooltip: "ChangeDimensions_Height_Tooltip",
      dataHook: PLUGIN_TOOLBAR_CONTAINER_HEIGHT_BUTTON,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DimensionSliderButton, { toolbarItem, dimension: "height" }),
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: HTML_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
